import type { ReactNode } from 'react';
import { Sidebar } from './Sidebar';

interface LayoutProps {
  children: ReactNode;
}

export function Layout({ children }: LayoutProps) {
  return (
    <div className="min-h-screen bg-dark-bg">
      <Sidebar />
      <main className="ml-[70px] p-5 min-h-screen">
        {children}
      </main>
    </div>
  );
}
